export class CustomerUser {
    fullname:string;
    username:string;
    jobtitle:string;    
    userrole:string;
    creator:string;
    created:string;
    email:string;
    phone?:string;
    userId:string;
    customerId:string;
    customerusercrmId:string;
    sendinvite:boolean;
    isactive?:boolean;
    validto:string;
    organizationId:string;
}